export enum SidePanel {
  Metadata = 'metadata',
  ActionsHistory = 'actionsHistory',
}
